import { Component } from '@angular/core';

@Component({
  selector: 'app-client-document',
  templateUrl: './client-document.component.html',
  styleUrl: './client-document.component.scss'
})
export class ClientDocumentComponent {

}
